const permissions = {
  operatorList: 'MB001',
  operatorAdd: 'MB002',
  operatorEdit: 'MB003',
  operatorDelete: 'MB004'
};

export default permissions;
